module.exports = __webpack_public_path__ + "img/BA.c1ba9013.jpg";